;; ============================================================================
;; AUTO-GENERATED — Developer Preview Page
;; This file is auto-generated for developer data inspection purposes.
;; It is NOT intended to be maintained as production UI.
;; ============================================================================
(ns hai.library.connections.preview
  (:require
   [com.wsscode.pathom3.connect.operation :as pco]
   [hai.library.connections.disposable-ui :as dui]
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [<s >e defevent defevent-fx defsub]]
   [hai.web-app.layout :as layout]
   [reagent.core :as r]))

;; ---------------------------------------------------------------------------
;; EQL Queries — Developer Reference
;;
;; These functions build EQL queries for Google Calendar resolvers.
;; They demonstrate key Pathom3 patterns:
;;   - Ident-based lookups:  [:gcal.calendar/id "cal-123"]
;;   - Parameterized joins:  (list :attr {:param "value"})
;;   - Optional attributes:  (pco/?) marks fields the resolver may omit
;;
;; Backend resolvers read params via (pco/params env).
;; See: projects/platform/src/hai/pathom/google_calendar.clj
;; ---------------------------------------------------------------------------

(def calendar-list-attrs
  "Attributes to fetch for the calendar list sidebar."
  [:gcal.calendar/id
   :gcal.calendar/summary
   :gcal.calendar/description
   :gcal.calendar/time-zone
   :gcal.calendar/primary?
   :gcal.calendar/access-role
   :gcal.calendar/background-color
   :gcal.calendar/foreground-color
   :gcal.calendar/color-id
   :gcal.calendar/selected?
   :gcal.calendar/hidden?])

(def event-attrs
  "Attributes to fetch for each event.
   Wrap conditionally-present fields with (pco/?) so Pathom doesn't
   error when the resolver omits them (e.g. color-id, conference-data)."
  [:gcal.event/id
   :gcal.event/summary
   :gcal.event/description
   :gcal.event/start
   :gcal.event/end
   :gcal.event/location
   :gcal.event/status
   (pco/? :gcal.event/attendees)
   (pco/? :gcal.event/organizer)
   :gcal.event/html-link
   :gcal.event/created
   :gcal.event/updated
   (pco/? :gcal.event/creator)
   (pco/? :gcal.event/recurrence)
   (pco/? :gcal.event/recurring-event-id)
   :gcal.event/transparency
   :gcal.event/visibility
   :gcal.event/ical-uid
   (pco/? :gcal.event/hangout-link)
   (pco/? :gcal.event/conference-data)
   (pco/? :gcal.event/reminders)
   (pco/? :gcal.event/color-id)
   :gcal.event/event-type])

(defn calendars-with-events-query
  "EQL query to list all calendars with their events in a single request.
   Nesting :gcal.calendar/events inside :gcal/calendars lets Pathom batch
   all calendar-events resolutions into one GCal batch HTTP call."
  [params]
  [{:gcal/calendars (into calendar-list-attrs
                          [{(list :gcal.calendar/events params) event-attrs}
                           :gcal.calendar/next-page-token])}])

(defn events-query
  "EQL query to fetch events for a specific calendar.
   Uses an ident lookup [:gcal.calendar/id cal-id] to target one calendar,
   then a parameterized join to pass :max-results, :time-min, :time-max
   to the calendar-events resolver (which forwards them to the GCal API).

   Example:
     (events-query \"primary\" {:max-results 25
                                :time-min \"2024-01-01T00:00:00Z\"
                                :time-max \"2024-02-01T00:00:00Z\"})"
  [cal-id params]
  [{[:gcal.calendar/id cal-id]
    [{(list :gcal.calendar/events params) event-attrs}]}])

;; ---------------------------------------------------------------------------
;; Date Helpers
;; ---------------------------------------------------------------------------

(defn- days-from-now
  "Returns an RFC3339 timestamp n days from now (negative = past)."
  [n]
  (let [d (js/Date.)]
    (.setDate d (+ (.getDate d) n))
    (.toISOString d)))

(defn- parse-int
  "Parses a string to int, returns nil for NaN."
  [s]
  (let [n (js/parseInt s 10)]
    (when-not (js/isNaN n) n)))

(def ^:private default-event-filters
  {:max-results 25
   :days-back 30
   :days-forward 30})

(defn- filters->params
  "Converts user-facing filter map to API params.
   :days-back / :days-forward are relative day counts converted to
   RFC3339 :time-min / :time-max timestamps."
  [{:keys [max-results days-back days-forward]}]
  (cond-> {}
    max-results  (assoc :max-results max-results)
    days-back    (assoc :time-min (days-from-now (- days-back)))
    days-forward (assoc :time-max (days-from-now days-forward))))

;; ---------------------------------------------------------------------------
;; Subscriptions
;; ---------------------------------------------------------------------------

(defsub ::connection-uuid [db]
  (get-in db [:routing/current-route :path-params :connection/uuid]))

(defsub ::calendars [db]
  (::calendars db))

(defsub ::selected-calendar-id [db]
  (::selected-calendar-id db))

(defsub ::events [db]
  (::events db))

(defsub ::loading-calendars? [db]
  (::loading-calendars? db))

(defsub ::loading-events? [db]
  (::loading-events? db))

(defsub ::error [db]
  (::error db))

(defsub ::event-filters [db]
  (or (::event-filters db) default-event-filters))

(defsub ::card-view? [db]
  (::card-view? db))

;; ---------------------------------------------------------------------------
;; Events
;; ---------------------------------------------------------------------------

(defevent-fx ::fetch-calendars
  [{:keys [db]} conn-uuid]
  (let [filters (or (::event-filters db) default-event-filters)
        params  (filters->params filters)]
    {:db (-> db
             (assoc ::loading-calendars? true)
             (assoc ::event-filters filters))
     :fetch {:url "/resolve"
             :method :post
             :body {:query (calendars-with-events-query params)
                    :options {:connection/uuid (uuid conn-uuid)}}
             :on-success-fx [[:dispatch [::calendars-loaded '?body]]]
             :on-error-fx [[:dispatch [::calendars-failed '?body]]]}}))

(defevent ::calendars-loaded [db response]
  (let [calendars (:gcal/calendars response)
        events-by-cal (into {}
                            (map (fn [cal]
                                   [(:gcal.calendar/id cal)
                                    (:gcal.calendar/events cal)]))
                            calendars)
        selected (::selected-calendar-id db)]
    (-> db
        (assoc ::calendars calendars)
        (assoc ::events-by-calendar events-by-cal)
        (assoc ::error nil)
        (assoc ::loading-calendars? false)
        (assoc ::loading-events? false)
        (cond->
         selected (assoc ::events (get events-by-cal selected))))))

(defevent ::calendars-failed [db response]
  (-> db
      (assoc ::error (or (:com.wsscode.pathom3.error/error-message response)
                         (str response)))
      (assoc ::loading-calendars? false)
      (assoc ::loading-events? false)))

(defevent ::select-calendar [db cal-id]
  (let [events (get-in db [::events-by-calendar cal-id])]
    (-> db
        (assoc ::selected-calendar-id cal-id)
        (assoc ::events events)
        (assoc ::loading-events? false))))

(defevent ::update-filter [db k v]
  (assoc-in db [::event-filters k] v))

(defevent-fx ::apply-filters
  [{:keys [db]}]
  (let [conn-uuid (get-in db [:routing/current-route :path-params :connection/uuid])]
    {:db (-> db
             (assoc ::events nil)
             (assoc ::loading-events? true))
     :dispatch [::fetch-calendars conn-uuid]}))

(defevent ::toggle-card-view [db]
  (update db ::card-view? not))

;; ---------------------------------------------------------------------------
;; View Components
;; ---------------------------------------------------------------------------

(defn event-card-view
  "Friendly card view for a single event."
  [evt]
  [dui/friendly-card
   [dui/friendly-card-title (or (:gcal.event/summary evt) "(No title)")]
   (when-let [start (dui/format-event-time (:gcal.event/start evt))]
     [dui/friendly-field
      [dui/friendly-label "Time"]
      [dui/friendly-value
       start
       (when-let [end (dui/format-event-time (:gcal.event/end evt))]
         (str " → " end))]])
   (when-let [loc (:gcal.event/location evt)]
     [dui/friendly-field
      [dui/friendly-label "Location"]
      [dui/friendly-value loc]])
   (when-let [status (:gcal.event/status evt)]
     [dui/friendly-field
      [dui/friendly-label "Status"]
      [dui/status-badge status]])
   (when-let [link (:gcal.event/html-link evt)]
     [dui/friendly-field
      [dui/friendly-label "Link"]
      [dui/event-link {:href link :target "_blank" :rel "noopener"} "Open in Google Calendar"]])])

(defn calendar-list-panel []
  (r/with-let [!calendars (<s [::calendars])
               !selected (<s [::selected-calendar-id])
               !loading? (<s [::loading-calendars?])
               !error (<s [::error])]
    [dui/left-panel
     [dui/section-heading "Calendars"]
     (cond
       @!loading?
       [dui/loading-text "Loading calendars..."]

       @!error
       [dui/error-text @!error]

       (empty? @!calendars)
       [dui/empty-state "No calendars found"]

       :else
       (let [selected @!selected]
         (for [cal @!calendars
               :let [cal-id (:gcal.calendar/id cal)]]
           ^{:key cal-id}
           [dui/calendar-item
            {:class (when (= cal-id selected) "selected")
             :on-click #(>e [::select-calendar cal-id])}
            [dui/calendar-title
             (when-let [bg (:gcal.calendar/background-color cal)]
               [:span {:style {:display "inline-block"
                               :width "10px" :height "10px"
                               :border-radius "2px"
                               :background bg
                               :flex-shrink 0}}])
             [:span {:style {:overflow "hidden"
                             :text-overflow "ellipsis"
                             :white-space "nowrap"}} (:gcal.calendar/summary cal)]
             (when (:gcal.calendar/primary? cal)
               [dui/primary-badge "primary"])]
            [dui/calendar-meta
             (:gcal.calendar/time-zone cal)
             (when-let [role (:gcal.calendar/access-role cal)]
               (str " · " role))]])))]))

(defn filter-panel []
  (r/with-let [!filters (<s [::event-filters])
               !events (<s [::events])
               !card-view? (<s [::card-view?])]
    [dui/filter-bar
     [:label "Max results "]
     [dui/filter-input {:type "number"
                        :value (or (:max-results @!filters) "")
                        :min 1 :max 2500
                        :on-change #(>e [::update-filter :max-results
                                         (parse-int (.. % -target -value))])}]
     [:label "Days back "]
     [dui/filter-input {:type "number"
                        :value (or (:days-back @!filters) "")
                        :min 0 :max 365
                        :on-change #(>e [::update-filter :days-back
                                         (parse-int (.. % -target -value))])}]
     [:label "Days forward "]
     [dui/filter-input {:type "number"
                        :value (or (:days-forward @!filters) "")
                        :min 0 :max 365
                        :on-change #(>e [::update-filter :days-forward
                                         (parse-int (.. % -target -value))])}]
     [dui/apply-btn {:on-click #(>e [::apply-filters])} "Apply"]
     [dui/view-toggle
      [dui/toggle-label "Cards"]
      [c/Switch {:checked (boolean @!card-view?)
                 :on-checked-change #(>e [::toggle-card-view])}]]
     (when-let [events @!events]
       [dui/event-count-text (str "Showing " (count events) " events")])]))

(defn events-panel []
  (r/with-let [!events (<s [::events])
               !loading? (<s [::loading-events?])
               !selected (<s [::selected-calendar-id])
               !calendars (<s [::calendars])
               !card-view? (<s [::card-view?])]
    (let [card-view? @!card-view?]
      [dui/right-panel
       (if-not @!selected
         [dui/empty-state "Select a calendar to view its events"]
         [:<>
          (let [cal (some #(when (= (:gcal.calendar/id %) @!selected) %) @!calendars)]
            (when cal
              [:div.mb-4
               [dui/section-heading "Calendar Details"]
               [dui/attr-table (dissoc cal :gcal.calendar/events :gcal.calendar/next-page-token)]]))
          [filter-panel]
          [dui/section-heading "Events"]
          (cond
            @!loading?
            [dui/loading-text "Loading events..."]

            (empty? @!events)
            [dui/empty-state "No events found"]

            :else
            [:div {:style {:display "flex" :flex-direction "column" :gap "8px"}}
             (for [evt @!events
                   :let [evt-id (or (:gcal.event/id evt) (random-uuid))]]
               ^{:key evt-id}
               (if card-view?
                 [event-card-view evt]
                 [dui/event-card
                  [dui/event-title (or (:gcal.event/summary evt) "(No title)")]
                  [dui/attr-table (dissoc evt :gcal.event/summary)]]))])])])))

;; ---------------------------------------------------------------------------
;; Page
;; ---------------------------------------------------------------------------

(defn page [_]
  (r/with-let [!conn-uuid (<s [::connection-uuid])]
    (>e [::fetch-calendars @!conn-uuid])
    (fn [_]
      [layout/page
       [layout/breadcrumbs]
       [layout/heading {:label "Calendar Data Explorer"}]
       [layout/content
        [dui/explorer-layout
         [calendar-list-panel]
         [events-panel]]]])))
